import createReactComponent from '../createReactComponent';
export default createReactComponent('heading-1', 'Heading1', [["path",{"d":"M3.75 4.5v15m9.5-15v15M3.75 12h9.5m3.25-.125 3-2.375v10","key":"svg-0"}]]);